import axios from 'axios';

let inFlightPromise = null;
let cachedItems = null;
let cachedTotal = null;
let lastFetchTime = 0;
const CACHE_TTL = 2000; // 2 seconds cache window for simultaneous component mounts

/**
 * Fetch cart items with in-flight request deduplication and short TTL caching
 * Prevents multiple identical requests from IndicatorCart, MobileHeader, and ShopPageCart
 */
export const getCartList = async (token, force = false) => {
    if (!token) {
        cachedItems = [];
        cachedTotal = 0;
        localStorage.setItem('cart_total', '0');
        return { items: [], total: 0 };
    }

    const now = Date.now();
    if (!force && cachedItems !== null && (now - lastFetchTime < CACHE_TTL)) {
        return { items: cachedItems, total: cachedTotal };
    }

    if (inFlightPromise) {
        return inFlightPromise;
    }

    inFlightPromise = (async () => {
        try {
            const res = await axios({
                method: 'GET',
                url: `${process.env.REACT_APP_HOST_API}/cart/list`,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            const data = res.data?.response;
            const items = Array.isArray(data) ? data : [];
            const total = items.reduce((acc, curr) => acc + (parseInt(curr.qty, 10) || 0), 0);

            cachedItems = items;
            cachedTotal = total;
            lastFetchTime = Date.now();
            localStorage.setItem('cart_total', String(total));

            return { items, total };
        } catch (error) {
            // Backend returns HTTP 400 "Keranjang Kosong" when cart is empty
            cachedItems = [];
            cachedTotal = 0;
            lastFetchTime = Date.now();
            localStorage.setItem('cart_total', '0');
            return { items: [], total: 0 };
        } finally {
            inFlightPromise = null;
        }
    })();

    return inFlightPromise;
};

/**
 * Update the local cart cache instantly (e.g. on optimistic delete / qty update)
 */
export const updateCartCache = (items) => {
    const list = Array.isArray(items) ? items : [];
    const total = list.reduce((acc, curr) => acc + (parseInt(curr.qty, 10) || 0), 0);
    cachedItems = list;
    cachedTotal = total;
    lastFetchTime = Date.now();
    localStorage.setItem('cart_total', String(total));
    return { items: list, total };
};

/**
 * Clear cache to force next getCartList to fetch from server
 */
export const clearCartCache = () => {
    cachedItems = null;
    cachedTotal = null;
    lastFetchTime = 0;
    inFlightPromise = null;
};
